import { useContext, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// import UnauthorizedPage from '@@/products/portal/pages/unauthorized-access-page';
import { determineUserPermissions } from '@@/lib/permissions';
import { AuthContext } from '@@/contexts/AuthContext';
import { DfcPermission, default as dfcPermissionMapping } from '../common/permission-mapping';
import { Spinner } from '@@/ui/components';

const Authorizer = () => {
  const { instanceData, loading, error } = useContext(AuthContext);
  const { pathname } = useLocation();

  const userPermissions = useMemo(() => {
    if (!instanceData?.permissions) return new Set<DfcPermission>();
    return determineUserPermissions(instanceData.permissions, pathname, dfcPermissionMapping);
  }, [instanceData?.permissions, pathname]);

  if (loading) {
    return (
      <div className='flex items-center justify-center h-full py-12'>
        <Spinner size='lg' className='stroke-1' />
      </div>
    );
  }

  if (error) {
    return <div aria-label={'API Error'}>API Error: {error.toString()}</div>;
  }

  return <Outlet context={{ permissions: userPermissions }} />;
  // Commented out temporarily.
  // if (userPermissions && userPermissions.size > 0) {
  //   return <Outlet context={{ permissions: userPermissions }} />;
  // }

  // return <UnauthorizedPage />;
};

export default Authorizer;
